var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.92588 2L2.40353 10.0282C2.41072 10.1479 2.4633 10.2603 2.55053 10.3425C2.63776 10.4247 2.75308 10.4705 2.87294 10.4706H7.12706C7.24692 10.4705 7.36224 10.4247 7.44947 10.3425C7.5367 10.2603 7.58928 10.1479 7.59647 10.0282L8.07412 2H1.92588ZM8.78177 2L8.30118 10.07C8.28333 10.3693 8.15187 10.6505 7.93365 10.8562C7.71543 11.0618 7.42691 11.1764 7.12706 11.1765H2.87294C2.57309 11.1764 2.28457 11.0618 2.06635 10.8562C1.84813 10.6505 1.71667 10.3693 1.69882 10.07L1.21824 2H0V1.58824C0 1.51023 0.0309874 1.43542 0.0861451 1.38026C0.141303 1.3251 0.216113 1.29412 0.294118 1.29412H9.70588C9.78389 1.29412 9.8587 1.3251 9.91386 1.38026C9.96901 1.43542 10 1.51023 10 1.58824V2H8.78177ZM6.17647 0C6.25448 0 6.32929 0.0309874 6.38444 0.0861451C6.4396 0.141303 6.47059 0.216113 6.47059 0.294118V0.705882H3.52941V0.294118C3.52941 0.216113 3.5604 0.141303 3.61556 0.0861451C3.67071 0.0309874 3.74552 0 3.82353 0H6.17647ZM3.52941 3.52941H4.23529L4.52941 8.82353H3.82353L3.52941 3.52941ZM5.76471 3.52941H6.47059L6.17647 8.82353H5.47059L5.76471 3.52941Z",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.163cc72c9ca6b9071b71fffd4059fdda.svg";
export { ForwardRef as ReactComponent };